import React from 'react';
import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";
export default function Breadcrumb({ data, title, children }) {
    const _data = (data || []).filter(a => !!a);
    const _title = title || (_data.length === 1 ? _data[0].name : _data.length > 1 ? React.createElement(React.Fragment, null,
        _data[_data.length - 1].name,
        " (",
        _data[0].name,
        ")") : null);
    return React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "align-items-end" },
            React.createElement(Col, null,
                React.createElement("div", { className: "page-title-box d-sm-flex align-items-center justify-content-between" },
                    _title && React.createElement("h4", { className: "mb-sm-0" }, _title),
                    React.createElement("div", { className: "page-title-right" },
                        React.createElement("ol", { className: "breadcrumb m-0" },
                            React.createElement("li", { className: "breadcrumb-item" },
                                React.createElement(Link, { to: "/", className: "breadcrumb-link" },
                                    React.createElement("i", { className: "fas fa-home" }))),
                            _data.map((a, i) => React.createElement("li", { key: i, className: "breadcrumb-item active" },
                                React.createElement(Link, { to: a.href, className: "breadcrumb-link" }, a.name)))))))),
        children);
}
